'use client'

import { Animation, Cell, EmptyState, Spacer, Text } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/shared/api-client'
import { useBreakpoint } from '@marketplace-web/shared/breakpoints'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useAsset } from '@marketplace-web/domain/assets'

import {
  getClosetPromotionPerformance,
  transformClosetPromoPerformanceResponse,
} from '@marketplace-web/domain/vas-data'

import Activity from './Activity'
import Views from './Views'
import LastUpdatedTime from './LastUpdatedTime'

const ClosetPromoStatistics = () => {
  const translate = useTranslate('closet_promotion.performance')
  const asset = useAsset('/assets/animations')
  const breakpoints = useBreakpoint()
  const {
    fetch: fetchClosetPromotionPerformance,
    transformedData: performance,
    isLoading,
  } = useFetch(getClosetPromotionPerformance, transformClosetPromoPerformanceResponse)

  useEffect(() => {
    fetchClosetPromotionPerformance()
  }, [fetchClosetPromotionPerformance])

  function renderEmptyState() {
    return (
      <>
        <Cell
          styling={Cell.Styling.Tight}
          title={<Text as="h1" type={Text.Type.Heading} text={translate('title')} />}
        />
        <Spacer size={Spacer.Size.XLarge} />
        <EmptyState
          title={translate('empty.title')}
          body={translate('empty.body')}
          animation={<Animation animationUrl={asset('feedback-empty-state.json')} />}
        />
      </>
    )
  }

  if (isLoading) return null

  if (!performance) return renderEmptyState()

  return (
    <>
      <div className="closet-promo-stats">
        <div className="closet-promo-stats__header">
          <div className="u-tablets-up-only">
            <Spacer size={Spacer.Size.Medium} />
          </div>
          <Cell
            styling={Cell.Styling.Tight}
            title={<Text as="h1" type={Text.Type.Title} text={translate('header.title')} />}
            body={
              <Text as="span" type={Text.Type.Subtitle} text={performance.endsInHours.humanized} />
            }
          />
        </div>
        <div className="closet-promo-stats__views">
          <Views performance={performance} />
        </div>
        <div className="closet-promo-stats__activity">
          <Activity performance={performance} />
        </div>
      </div>
      <Spacer size={breakpoints.tabletsUp ? Spacer.Size.XLarge : Spacer.Size.Large} />
      <LastUpdatedTime lastUpdatedTime={performance.updatedAt} />
    </>
  )
}

export default ClosetPromoStatistics
